import type React from 'react';

import { Text } from '@change/ds-core-ui/Text';

import { TypedTranslate } from '@change-corgi/core-react/i18n';

import type { WhoUsesCardType } from '../../consts';

export const WhoUsesCard: React.FC<WhoUsesCardType> = ({ Icon, title, description }) => {
	return (
		<div
			className="border-stroke-weaker bg-background-base flex flex-col gap-5 rounded-2xl border p-6 md:p-7"
			data-qa="impact-who-uses-card"
		>
			<div
				aria-hidden="true"
				className="bg-fill-selected-weaker text-icon-information flex size-18 items-center justify-center rounded-lg"
				data-qa="impact-who-uses-icon-tile"
			>
				<Icon size={44} />
			</div>
			<div className="flex flex-col gap-2">
				<Text as="h3" variant="heading" size="x-small">
					<TypedTranslate value={title} />
				</Text>
				<Text as="p" size="small" className="text-typography-weak">
					<TypedTranslate value={description} />
				</Text>
			</div>
		</div>
	);
};
